import React from "react"
import { Helmet } from "react-helmet"

export const Header = () => {
    return (
        <>
            <Helmet>
                <meta name="description" content="Portfolio, Web Developer, React, Typescript, Webpack, Node.js" />
                <meta http-equiv="X-UA-Compatible" content="IE=edge" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta charSet="utf-8" />
                <title>Kevin Cheng</title>
            </Helmet>
        </>
    )
}